import { __rest } from "tslib";
import React from 'react';
import { useFetchExperiments } from './useFetchExperiments';
export var WithExperiments = function (_a) {
    var children = _a.children, fallback = _a.fallback, options = __rest(_a, ["children", "fallback"]);
    var _b = useFetchExperiments(options), experimentsInstance = _b.experimentsInstance, ready = _b.ready;
    if (!ready) {
        return fallback ? fallback : null;
    }
    return React.createElement(React.Fragment, null, children(experimentsInstance));
};
//# sourceMappingURL=WithExperiments.js.map